export type JsmWidgetInfoFeatureFlagsDto = {
  omnichannel_for_widget: boolean;
};

export type JsmWidgetInfoDto = {
  version: string;
  environment: string;
  cloudId: string;
  activationId: string;
  baseUrl: string;
  projectId: number;
  featureFlags: JsmWidgetInfoFeatureFlagsDto;
};

export type JsmWidgetFormFieldDefaultValueDto = {
  value: string;
  label: string;
};

export type JsmWidgetFormFieldPossibleValueDto = {
  value: string;
  label: string;
};

export type JsmWidgetFormFieldDto = {
  id: string;
  name: string;
  description: string;
  required: boolean;
  value: string;
  type: string;
  defaultValues: JsmWidgetFormFieldDefaultValueDto[];
  possibleValues: JsmWidgetFormFieldPossibleValueDto[];
};

export const JsmWidgetFormFieldTypeMap: Record<string, string> = {
  SINGLE_LINE_TEXT: 'text',
  REPORTER_EMAIL: 'email',
  MULTI_LINE_TEXT: 'textarea',
  SINGLE_SELECT: 'select',
  ATTACHMENT: 'file',
  CHECKBOX: 'checkbox-group',
  RADIO: 'radio',
  DATE: 'date',
};

export type JsmWidgetFormDto = {
  id: string;
  name: string;
  description: string;
  fields: JsmWidgetFormFieldDto[];
};

export type JsmWidgetConfigurationDto = {
  serviceDeskId: number;
  requestTypeId: number;
  widgetEnabled: boolean;
  rtSearchEnabled: boolean;
  kbEnabled: boolean;
  widgetButtonTextEnabled: boolean;
  backgroundPattern: string;
  widgetType: string;
  headerText: string;
  confirmationText: string;
  widgetButtonText: string;
  primaryColorHex: string;
};

export type JsmWidgetConfigDto = {
  config: JsmWidgetFormDto;
};

export type JsmWidgetDto = {
  info: JsmWidgetInfoDto;
  form: JsmWidgetFormDto;
  configuration: JsmWidgetConfigurationDto;
  config: JsmWidgetConfigDto;
};

export type JsmWidgetArticleDto = {
  id: string;
  title: string;
  contentUrl: string;
};

export type JsmWidgetSearchResponseDto = {
  articles: JsmWidgetArticleDto[];
  requestTypes: JsmWidgetFormDto[];
};
